// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.enterprise.events.RentalManagerEnterpriseEventTrackingWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { EnterpriseListingEvent, EnterprisePageFeature } from '../..';

interface TrackCustomerListingEventParams {
  event: EnterpriseListingEvent;
  feedId: string;
  feedListingId: string;
}
interface TrackPageVisitParams {
  page: EnterprisePageFeature;
}

export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path =
  '/api/web/v1/users/enterprise/events/trackCustomerListingEvent';

/**
 * Track enterprise listing event
 */
export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent = (
  getParams: TrackCustomerListingEventParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<TrackCustomerListingEventParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit_Path =
  '/api/web/v1/users/enterprise/events/trackPageVisit';

/**
 * Track enterprise page visit
 */
export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit = (
  getParams: TrackPageVisitParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<TrackPageVisitParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerEnterpriseEventTrackingWebApiHandler_trackPageVisit_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
